var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",staticStyle:{"height":"100%","overflow":"auto"}},[_c('el-backtop',{attrs:{"target":".home"}}),_c('Header'),_c('Banner'),_vm._l((_vm.subList),function(item,i){return _c('div',{key:item.id},[_c('Special',{attrs:{"title":item.cateName,"children":item.courseList}})],1)}),(_vm.isLOgin)?_c('Buy'):_vm._e(),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }